module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-5-6fc1fe32ebe27904ac0727872171dbf4.jpg";